const productdetail = [
    {
        id:1,
        title: "MEN'S GRAY T-SHIRT",
        image:require('./Images/19.webp'),
        price:65.25,
        count:1
    },
    {
        id:2,
        title: "MEN'S BLACK W-SUIT",
        image:require('./Images/16.webp'),
        price:57.88,
        count:1
    },
    {
        id:3,
        title: "MEN'S BLUE T-SHIRT",
        image:require('./Images/17.webp'),
        price:75.99,
        count:1
    },
    {
        id:4,
        title: "MEN'S BLACK T-SHIRT",
        image:require('./Images/18.webp'),
        price:55.25,
        count:1
    },
    
]
export default productdetail;